import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Card, CardContent, CardActions, Grid } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useAPI } from "../context/ApiContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  card: { maxWidth: 360, marginBottom: "1rem", height: 200 },
  cardContent: { minHeight: "130px", overflow: "hidden" },
});

const ellipsize = (str, n = 24) => (!str ? "" : str.length > n ? `${str.slice(0, n)}...` : str);

const PeopleCard = ({ item, isFollowingInitial, onFollowChange }) => {
  const classes = useStyles();
  const api = useAPI();
  const { t } = useTranslation();
  const history = useHistory();

  const userId = item?.userId || item?.userProfile || item?.id;
  const nickname = item?.nickname || item?.nickName || "User";
  const caption = item?.caption || item?.description || "";
  const image = item?.image || item?.img || "";

  const isMe = useMemo(() => !!api.myUserId && api.myUserId === userId, [api.myUserId, userId]);

  // ---- 初期フォロー状態（親 > サーバ返却 > 既定false）
  const derivedInitial = item?.isFollowedByMe ?? false;

  const [following, setFollowing] = useState(!!derivedInitial);
  const [busy, setBusy] = useState(false);

  // ★ 親の isFollowingInitial が後から判明した時に同期
  useEffect(() => {
    setFollowing(!!derivedInitial);
  }, [derivedInitial]);

  const toUser = () => {
    if (userId) history.push(`/user/${userId}`);
  };

  const handleFollow = async (e) => {
    e.stopPropagation();
    if (!api.isAuthenticated) return;
    try {
      setBusy(true);
      setFollowing(true);               // 楽観更新
      onFollowChange?.(userId, true);   // 親にも反映
      await api.follow(userId);
    } catch {
      setFollowing(false);              // 失敗時ロールバック
      onFollowChange?.(userId, false);
    } finally {
      setBusy(false);
    }
  };

  const handleUnfollow = async (e) => {
    e.stopPropagation();
    if (!api.isAuthenticated) return;
    try {
      setBusy(true);
      setFollowing(false);              // 楽観更新
      onFollowChange?.(userId, false);  // 親にも反映
      await api.unfollow(userId);
    } catch {
      setFollowing(true);               // 失敗時ロールバック
      onFollowChange?.(userId, true);
    } finally {
      setBusy(false);
    }
  };

  const avatarSrc =
    image?.startsWith("http")
      ? image
      : image
      ? `${api.API_BASE || ""}${image}`
      : "https://tatami.site/default_user_image.jpg";

  return (
    <div className="col-md-3 col-sm-4 pe-2 ps-2">
      <Card className={clsx(classes.card, "card shadow-xss")} onClick={toUser}>
        <CardContent className={clsx(classes.cardContent, "text-center", "mycard")}>
          <figure className="overflow-hidden avatar ms-auto me-auto mb-3 position-relative w65 z-index-1 pointer">
            <img src={avatarSrc} alt="avatar" className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" />
          </figure>

          <h4 className="fw-700 font-xsss mt-3 mb-0">{ellipsize(nickname, 18)}</h4>
          {caption && (
            <h4 className="fw-700 font-xsssss text-grey-600 mt-2 mb-0">{ellipsize(caption, 24)}</h4>
          )}
        </CardContent>

        <CardActions className="mycard" onClick={(e) => e.stopPropagation()}>
          <Grid container justifyContent="center">
            {isMe ? (
              <Grid item>
                <Link
                  to="/userpage"
                  className="mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-grey font-xsssss fw-700 ls-lg text-white"
                >
                  {t("RecommenduserEach1") || "あなた"}
                </Link>
              </Grid>
            ) : api.isAuthenticated ? (
              <Grid item>
                {!following ? (
                  <button
                    className="mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white"
                    onClick={handleFollow}
                    disabled={busy}
                  >
                    {t("RecommenduserEach2") || "フォロー"}
                  </button>
                ) : (
                  <button
                    className="mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-grey font-xsssss fw-700 ls-lg text-white"
                    onClick={handleUnfollow}
                    disabled={busy}
                  >
                    {t("RecommenduserEach3") || "フォロー中"}
                  </button>
                )}
              </Grid>
            ) : (
              <Grid item>
                <button
                  className="mt-0 btn pt-2 pb-2 ps-3 pe-3 lh-24 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white"
                  onClick={toUser}
                >
                  ユーザーページ
                </button>
              </Grid>
            )}
          </Grid>
        </CardActions>
      </Card>
    </div>
  );
};

export default PeopleCard;
